import { categories, getCategoryBySlug } from '@/mocks/categories';

interface CategoryHeroProps {
  categorySlug?: string;
}

export default function CategoryHero({ categorySlug }: CategoryHeroProps) {
  const category = categorySlug ? getCategoryBySlug(categorySlug) : undefined;

  return (
    <section className="relative h-[60vh] min-h-[420px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20anime%20style%20collage%20of%20manga%20panel%20layouts%20and%20comic%20speech%20bubbles%2C%20warm%20terracotta%20and%20cream%20tones%2C%20artistic%20storyboard%20composition%2C%20soft%20gradient%20overlay%2C%20creative%20editorial%20design%2C%20japanese%20manga%20inspired%20pattern&width=1920&height=1080&seq=cat-hero-bg-01&orientation=landscape"
          alt="漫画分类 - 178漫画网"
          title="按类型筛选高清漫画全集 - 178漫画网"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
        {category ? (
          <>
            <span className="inline-block px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs font-medium border border-white/20 mb-4">
              {category.comicCount} 部作品
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white">
              {category.name}
            </h1>
            <p className="mt-4 text-sm md:text-base text-white/70 max-w-md">
              {category.description}
            </p>
          </>
        ) : (
          <>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white">
              全部分类
            </h1>
            <p className="mt-4 text-sm md:text-base text-white/70 max-w-md">
              按类型筛选，发现下一部心动作品
            </p>
          </>
        )}
      </div>
    </section>
  );
}